import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator, FormControl } from '@angular/forms';
@Directive({
   selector: '[MultiSelectRequired]',
   // We add our directive to the list of existing validators
   providers: [
     { provide: NG_VALIDATORS, useExisting: MultiSelectValidator, multi: true }
   ]
})
export class MultiSelectValidator implements Validator {
    // This method is the one required by the Validator interface
    validate(c: FormControl): ValidationErrors | null {
    // Here we call our static validator function
    return MultiSelectValidator.validateRequired(c);
    }
    static validateRequired(control: FormControl): ValidationErrors {
        if (control.value === undefined || control.value == null || control.value.length == 0) {
            return {multiselect : 'Value required'};
        } else {
            return null;
        }
    }
}
